module.exports = __webpack_public_path__ + "static/media/ms____.eafb59af.svg";